export var getAttribute = function (attr, el) { return el.getAttribute(attr); };
